import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from 'common/components/index';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { ReactComponent as SuccessIcon } from 'applicaiton/assets/success-icon.svg';
import { StyledModal } from './styles';
import { Modal } from '@mui/material';
import { SuccessResendLinkProps } from './modules';

/**
 * A component for displaying a modal to indicate that a link has been successfully resent.
 * @param props - An object containing the component's properties.
 * @returns The rendered component.
 */
const SuccessResendLink: FC<SuccessResendLinkProps> = ({ onClose, email }) => {
  const { t } = useTranslation();
  return (
    <Modal open={true}>
      <StyledModal>
        <CloseIcon onClick={onClose} />
        <div>
          <SuccessIcon />
          <p>{`${t(
            'professionalsListConfiguration.resend_access_link_modal',
          )} ${email}`}</p>
          <SecondaryButton onClick={onClose}>
            {t('users.password_modal.ok')}
          </SecondaryButton>
        </div>
      </StyledModal>
    </Modal>
  );
};

export default SuccessResendLink;
